import React, { Fragment, useState, useEffect, useRef } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  self: {
    position: "absolute",
    alignSelf: "flex-start",
  },
  canvas: {
    margin: theme.spacing(2),
  },
}));

const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () =>
      reject(new Error(`load ${process.env.PUBLIC_URL + "/" + url} fail`));
    img.src = process.env.PUBLIC_URL + url;
  });
};

function DataSelfie(props) {
  const classes = useStyles();
  const respCanvasEl = useRef(null);
  useEffect(async () => {
    const response = props.response;
    const school = props.school;

    if (!response || !school) {
      return;
    }
    // console.log('drawing data selfie', response);

    const ctx = respCanvasEl.current.getContext("2d");
    // new Image()
    response
      .reverse()
      .filter((q) => q.visualized)
      .forEach((q) => {
        if (q.type === "checkbox") {
          q.options
            .filter((o) => o.checked)
            .forEach(async (o) => {
              console.log("option", o.image);
              const img = await loadImage(
                process.env.PUBLIC_URL + "/" + o.image
              );
              ctx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                respCanvasEl.current.width,
                respCanvasEl.current.height
              );
            });
        } else if (q.selected !== "") {
          q.options
            .filter((o) => o.label === q.selected)
            .forEach(async (o) => {
              const img = await loadImage(
                process.env.PUBLIC_URL + "/" + o.image
              );
              ctx.drawImage(
                img,
                0,
                0,
                img.width,
                img.height,
                0,
                0,
                respCanvasEl.current.width,
                respCanvasEl.current.height
              );
            });
        }
      });

    ctx.font = "14px Arial";
    ctx.textAlign = "center";
    ctx.fillText(
      school.match(/\b([A-Z])/g).join(""),
      props.width / 2,
      props.height - 28
    );
  }, []);
  const { width = 256, height = 256 } = props;
  return (
    <Fragment>
      <Paper
        className={classes.paper}
        style={{ width: width + 20, height: height + 20 }}
        elevation={0}
      >
        {props.self && (
          <Box className={classes.self}>
            <Typography variant="caption" display="block" gutterBottom>
              MY RESPONSE
            </Typography>
          </Box>
        )}
        <canvas
          className={classes.canvas}
          ref={respCanvasEl}
          width={width}
          height={height}
        ></canvas>
      </Paper>
    </Fragment>
  );
}

export default DataSelfie;
